/* GameEditorToggleIcon.js */

'use strict';
const ToggleIcon = require('@gluenetworks/steve_ui_core').IconTypes['toggle-icon-gl'];

class GameEditorToggleIcon extends ToggleIcon {
  // createdCallback(){
  //     super.createdCallback(arguments);
  // }
  // attachedCallback(){
  //     super.attachedCallback(arguments);
  // }
  // attributeChangedCallback(/*attrName, oldVal, newVal*/){
  //     super.attributeChangedCallback(arguments);
  // }
  // detachedCallback(){
  //     super.detachedCallback(arguments);
  // }
}

let icon,
  customElementRegistry = window.customElements;

if (customElementRegistry) {
  icon = customElementRegistry.get('game-editor-toggle-icon-gl');
  if (!icon) {
    customElementRegistry.define('game-editor-toggle-icon-gl', GameEditorToggleIcon);
    icon = customElementRegistry.get('game-editor-toggle-icon-gl');
  }
} else if (document.registerElement) {
  icon = document.registerElement('game-editor-toggle-icon-gl', GameEditorToggleIcon);
} else {
  icon = GameEditorToggleIcon;
}

module.exports = icon;
